export default function Intro() {
  return (
    <section className="max-w-3xl mx-auto px-6 py-20" data-testid="intro-section">
      <p
        className="text-2xl md:text-3xl font-light text-slate-700 leading-snug tracking-tight"
        data-testid="intro-paragraph"
      >
        Most founders don't lack ideas.
        <br />
        <span style={{ color: "#1e293b" }}>
          They lack clarity on what to do next.
        </span>
      </p>

      <p className="mt-8 text-base md:text-lg text-slate-500 leading-relaxed max-w-xl">
        This is a thinking tool — not a form. It helps you challenge assumptions,
        sharpen your idea, and leave with a practical plan you actually believe
        in.
      </p>
    </section>
  );
}
